<template>
  <div class="full-height flex-column">
    <div class="custom-tab">
      

      <div class="custom-tab-header">
        <b-row>
          <b-col cols="6">
            <b-form-group class="mode-group">
              <b-form-radio-group button-variant="outline-custom" buttons v-model="isActivated" :options="options" class="active"></b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col cols="3" class="text-right relative search-input-container">
            <b-input v-model="searchText" class="mb-2 mr-sm-2 mb-sm-0 search-input" id="search_text" type="text" placeholder="search"></b-input>
            <div class="search-icon-container">
              <magnifier-icon class="icon-default search-icon"></magnifier-icon>
            </div>
          </b-col>
          <b-col cols="3">
          <div class="text-right action-btn-cont">
        <b-btn variant="primary" @click="showInstallPluginsModal">Install Plugins And Themes</b-btn>
      </div>
      </b-col>
        </b-row>
      </div>
      <div class="custom-tab-body hasfooter">
        <b-tabs @input="tabSelected">
          <b-tab active>
            <template slot="title">
              <span class="title-count">{{pluginsAndThemes['plugins'].length}}</span>
              <span class="tab-title-wrapper ">
                <i class='img-icon plugin'></i>
                <span class="tab-title">
                  {{ 'Plugin' | pluralize(pluginsAndThemes['plugins'].length)}}
                </span>
              </span> </template>
              <div v-if="currentTabIndex==0">
                <entity-manager :entities="pluginsAndThemes['plugins']" @selectAll="select" type="plugins" :isActivated="isActivated">
                </entity-manager>
              </div>
          </b-tab>
          <b-tab>
            <template slot="title">
              <span class="title-count">{{pluginsAndThemes['themes'].length}}</span>
            <span class="tab-title-wrapper ">
              <i class='img-icon themes'></i>
              <span class="tab-title">
                {{ 'Theme' | pluralize(pluginsAndThemes['themes'].length)}}
              </span>
            </span>
            </template>
            <div v-if="currentTabIndex==1">
              <entity-manager :entities="pluginsAndThemes['themes']" type="themes" :isActivated="isActivated">
              </entity-manager>
            </div>
          </b-tab>
        </b-tabs>
      </div>
      <install-plugins-and-themes ref="installPluginsAndThemes"></install-plugins-and-themes>
    </div>

  </div>

  </template>

<script>
import Vue from "vue";

import utilsMixin from "../../mixins/utils";
import MagnifierIcon from "../../assets/lens.svg";
import InstallPluginsAndThemes from "../Manage/InstallPluginsAndThemes";

import EntityManager from "../Manage/EntityManager";
import EmptyPlaceholder from "../Common/EmptyPlaceholder";

export default {
  name: "pluginsandthemes",
  mixins: [utilsMixin],
  mounted() {
    //this.showInstallPluginsModal();
  },
  components: {
    InstallPluginsAndThemes,
    MagnifierIcon,
    EntityManager,
    EmptyPlaceholder
  },
  data() {
    return {
      plugins: [],

      currentTabIndex: 0,
      selectAllPlugins: false,
      selectAllThemes: false,
      searchText: "",
      isActivated: true,
      options: [
        { text: "Active", value: true },
        { text: "Inactive", value: false }
      ]
    };
  },
  computed: {
    sites() {
      return this.$store.getters.getSites;
    },
    getSelectedSites() {
      return this.$store.getters.selectedSites;
    },
    getPluginsAndThemes() {
      return this.$store.getters.getPluginsAndThemes;
    },
    rawPluginsAndThemes() {
      let selectedSitesMap = _.keyBy(this.getSelectedSites, "siteID");
      let sitePluginsAndThemes = this.$store.getters.getPluginsAndThemes;
      sitePluginsAndThemes = _.filter(sitePluginsAndThemes, {
        isActivated: this.isActivated
      });
      sitePluginsAndThemes = sitePluginsAndThemes.filter(pluginAndTheme => {
        return (
          pluginAndTheme.name
            .toLowerCase()
            .indexOf(this.searchText.toLowerCase()) > -1
        );
      });
      let updates = [];
      _.each(sitePluginsAndThemes, siteUpdate => {
        let siteId = siteUpdate.siteID;
        let site = selectedSitesMap[siteId];
        if (site) {
          let item = Object.assign({}, siteUpdate, { siteName: site.name });
          return updates.push(item);
        }
      });
      return updates;
    },
    pluginsAndThemes() {
      let updates = this.rawPluginsAndThemes;
      let processedPluginsAndThemes = {
        plugins: [],
        themes: []
      };
      let groupByType = _.groupBy(updates, "type");
      _.each(groupByType, (group, key) => {
        let groupByURI = _.groupBy(group, "URI");
        processedPluginsAndThemes[key] = _.chain(group)
          .groupBy("URI")
          .toPairs()
          .map(function(currentItem) {
            currentItem.push(currentItem[1][0].name);
            return _.zipObject(["URI", "sites", "name"], currentItem);
          })
          .value();
      });

      return processedPluginsAndThemes;
    }
  },
  watch: {
    pluginsAndThemes() {
      Vue.nextTick().then(() => {
        this.$forceUpdate();
      });
    }
  },
  methods: {
    select(payload) {
      let sites = _.filter(this.rawPluginsAndThemes, { type: payload.type });
      this.$store.commit({
        type: "SELECT_GROUP_PLUGINS_AND_THEMES",
        sites: sites,
        value: payload.value
      });
    },

    tabSelected(index) {
      this.currentTabIndex = index;
    },
    showInstallPluginsModal() {
      this.$refs.installPluginsAndThemes.$refs.installPluginsAndThemesModal.show();
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/PluginsAndThemes.vue